export default "__VITE_ASSET__4bba268a__"